import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';

const SelectJsonApi = ({ name, options, ...OtherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (evt) => {
    const { value } = evt.target;
    setFieldValue(name, value);
  };

  const configSelect = {
    ...field,
    ...OtherProps,
    select: true,
    fullWidth: true,
    size: 'small',
    variant: 'outlined',
    InputLabelProps: {
      shrink: true
    },
    onChange: handleChange
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    configSelect.helperText = meta.error;
  }

  return (
    <TextField {...configSelect}>
      {Object.keys(options).map((item, pos) => (
        <MenuItem key={options[item].id} value={options[item].id}>
          {options[item].value}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectJsonApi;
